export default __webpack_public_path__ + "static/media/LOB1.91224086.webp";